var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-link',{staticClass:"o-typography__headline5 o-typography--action u-text-transform-none",class:{
    'c-section__view-all': _vm.isTile,
    'o-typography--action-invert': !_vm.isTile,
    'c-section__header-additional': !_vm.isTile,
  },attrs:{"to":_vm.path || _vm.sectionRoute}},[_vm._v(" "+_vm._s(_vm.text)+" "),_c('i',{staticClass:"o-icon o-icon--right"})])
}
var staticRenderFns = []

export { render, staticRenderFns }